import { RegionShared } from "@1games-ru/region-shared";
import { SpawnType } from "@1games-ru/region-shared/dist/enums/selectSpawn/type";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class SpawnMpProvider {
  public static async setActiveSpawnType(
    spawnType: SpawnType,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.SelectSpawnSetActiveTypeResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.SelectSpawnSetActiveTypeRequest,
      typeof RegionShared.Client.Responses.SelectSpawnSetActiveTypeResponse
    >(RegionShared.Client.Events.SelectSpawn.SetActiveType, { spawnType });
  }

  public static async setHoverSpawnType(
    spawnType: SpawnType,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.SelectSpawnSetHoverTypeResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.SelectSpawnSetHoverTypeRequest,
      typeof RegionShared.Client.Responses.SelectSpawnSetHoverTypeResponse
    >(RegionShared.Client.Events.SelectSpawn.SetHoverType, { spawnType });
  }

  public static async confirmSpawnType(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.SelectSpawnConfirmActiveResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.SelectSpawnConfirmActiveRequest,
      typeof RegionShared.Client.Responses.SelectSpawnConfirmActiveResponse
    >(RegionShared.Client.Events.SelectSpawn.ConfirmActive, {});
  }
}
